import React from 'react';
import {connect} from 'react-redux';

// Components
import Anchor from 'Components/common/Anchor';
import BasicButton from 'Components/common/BasicButton';
import BasicTextArea from 'Components/common/BasicTextArea';
import util from 'Utils/commonUtil';
// Actions
import {getFeedbackList, feedbackSave, setShipmentsSource} from 'Actions/host';
import {openNotification} from 'Actions/notification';
import {T} from 'Actions/translate';

import {Grid} from '@material-ui/core';
// Icons
import {ArrowBackIos} from '@material-ui/icons';

class CustomerFeedBack extends React.Component {
    state = {
        remark: '',
        remarkNum: 0,
        feedbackContent: '',
    };

    componentWillMount() {
        let shipmentItemInfo = this.getShipmentItemInfor();
        this.props.getFeedbackList(shipmentItemInfo.id);
    }

    gotoPrePage = () => {
        this.props.setShipmentsSource({$set: true});
        this.props.history.goBack();
    };

    textChange = (title, value) => {
        if (value && value.length > 0) {
            let num = value && value.length;
            if (num >= 200) {
                num = 200;
            }

            this.setState({
                remarkNum: num,
                remark: value,
            });
        }
    };

    clearInput = () => {
        this.setState({
            remarkNum: 0,
            feedbackContent: '',
        });
    };

    getShipmentItemInfor = () => {
        let shipmentItem = undefined;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            shipmentItem = routerState.shipmentItem;
        }
        return shipmentItem;
    };

    submitFeedback = () => {
        let shipmentItemInfo = this.getShipmentItemInfor();
        let {feedbackContent} = this.state;
        let flg = true;
        let feedBackParams = {
            orderId: shipmentItemInfo.id,
            shipmentId:
                shipmentItemInfo.shipments &&
                shipmentItemInfo.shipments.length > 0
                    ? shipmentItemInfo.shipments[0].id
                    : '',
            feedback: feedbackContent,
        };
        if (feedbackContent) {
            flg = false;
            this.props.feedbackSave(feedBackParams).then((res) => {
                if (res && res.status === 'success') {
                    this.props.getFeedbackList(shipmentItemInfo.id);
                    this.props.openNotification(
                        T('shippment_customer_feedback_success'),
                        'success',
                        {bubbling: true},
                    );
                    this.setState({
                        remarkNum: 0,
                        feedbackContent: '',
                    });
                }
            });
        } else if (!feedbackContent) {
            this.props.openNotification(
                T('shippment_customer_feedback_content_is_not_null'),
                'danger',
                {bubbling: true},
            );
        }
    };

    handleTextArea = (name, value) => {
        if (value && value.length > 0) {
            let num = value && value.length;
            if (num >= 200) {
                num = 200;
            }
            this.setState({
                remarkNum: num,
                feedbackContent: value,
            });
        }
    };

    render() {
        const {remarkNum, feedbackContent} = this.state;
        const {customerFeedbackList} = this.props;

        return (
            <div className="customer-feedback-container">
                <div className="customer-feedback-header container-max-width is-fixed">
                    <Anchor
                        className="back-btn"
                        onClickOfSingleTap={this.gotoPrePage}>
                        <ArrowBackIos className="back-icon" />
                    </Anchor>
                    {T('shippment_customer_feedback')}
                </div>
                <Grid
                    item
                    xs={12}
                    className="customer-feedback-content no-required-laebl">
                    <BasicTextArea
                        type="text"
                        inputValid={this.handleTextArea}
                        defalutValue={feedbackContent}
                        clearInput={this.clearInput}
                        maxlength={200}
                        value={feedbackContent}
                        placeholder={T(
                            'shippment_please_input_customer_feedback',
                        )}
                    />
                    <div className="customer-feedback-num">{remarkNum}/200</div>
                </Grid>

                <div className="customer-feedback-btn-container">
                    <BasicButton
                        className="cancel-btn"
                        type="primary"
                        onClickOfSingleTap={this.gotoPrePage}>
                        {T('shippment_customer_feedback_cancel')}
                    </BasicButton>
                    <BasicButton
                        className="submit-btn"
                        type="primary"
                        onClickOfSingleTap={this.submitFeedback}>
                        {T('shippment_customer_feedback_submit')}
                    </BasicButton>
                </div>

                {customerFeedbackList && customerFeedbackList.length > 0 ? (
                    <div className="customer-feedback-list-contanier">
                        <div className="feedback-list-title">
                            {T('shippment_feedback_history')}
                        </div>
                        <ul className="feedback-list-ul">
                            {customerFeedbackList.map((item, index) => (
                                <li className="feedback-list-li">
                                    <div>{item.feedback}</div>
                                    <div className="feedback-create">
                                        {item.createTime}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData, userCenter, host, auth} = state;

    return {
        localData,
        SCList: userCenter.SCList,
        alphaList: userCenter.alphaList,
        inventoryInfor: userCenter.inventoryInfor,
        customerFeedbackList: host.customerFeedbackList,
        adminUser: auth.adminUser,
    };
};

const mapDispatchToProps = {
    getFeedbackList,
    feedbackSave,
    setShipmentsSource,
    openNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerFeedBack);
